<template>
  <div class="sr2f-social">
    <ShareNetwork
      network="facebook"
      :url="sharing.url"
      :title="sharing.title"
      :description="sharing.description"
      :hashtags="sharing.hashtags"
      :quote="sharing.title"
      id="facebook-btn-sharing"
    >
      <img
        class="sr2fs-img"
        src="@/assets/icons/facebook-square-brands.svg"
        alt="facebook"
      />
    </ShareNetwork>
    <ShareNetwork
      network="twitter"
      :url="sharing.url"
      :title="sharing.title"
      :hashtags="sharing.hashtags"
      id="twitter-btn-sharing"
    >
      <img
        class="sr2fs-img"
        src="@/assets/icons/twitter-square-brands.svg"
        alt="twitter"
      />
    </ShareNetwork>
    <ShareNetwork
      id="linkedin-btn-sharing"
      network="linkedin"
      :title="sharing.title"
      :url="sharing.url"
    >
      <img
        class="sr2fs-img"
        src="@/assets/icons/linkedin-brands.svg"
        alt="linkedin"
      />
    </ShareNetwork>
  </div>
</template>

<script>
export default {
  name: "SocialSharing",
  data() {
    return {
      sharing: {
        url: "https://dev.taxliteracy.academy",
        title:
          "ลอง เล่น รู้ เข้าใจ เลือกรูปแบบภาษี และเส้นทางในการประกอบธุรกิจของคุณง่ายๆ",
        description:
          "Web นี้ช่วยให้คุณเข้าใจและสามารถ เลือกแนวทางการวางแผนภาษี โดยคำนึงถึงเงินสดในมือ เพื่อการเติบโตอย่างยั่งยืนของธุรกิจ",
        hashtags:
          "แนวทางการวางแผนภาษี,ยื่นภาษีธุรกิจ,ยื่นภาษีง่าย,ช่วยคิดเรื่องภาษี",
      },
    };
  },
};
</script>

<style scoped>
.sr2f-social {
  cursor: pointer;
  margin-bottom: 35px;
}
.sr2fs-img {
  margin-right: 15px;
}
</style>
